// The site's languages, in the order the language menu lists them. To add
// one: add it here, add a dictionary next to this file (see de.js), a
// loader in index.js, and the game content in each game's content file.
export const LANGUAGES = [
  { code: "en", name: "English", dir: "ltr" },
  { code: "de", name: "Deutsch", dir: "ltr" },
  { code: "fr", name: "Français", dir: "ltr" },
  { code: "ar", name: "العربية", dir: "rtl" },
];

export const DEFAULT_LANG = "en";
export const isLang = (code) => LANGUAGES.some((l) => l.code === code);
export const langInfo = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
